// Б.2.d: Личный телохранитель — пассивка onSpawn.
//
// При появлении на поле (или в момент пробуждения, если выставлен в Режиме
// ожидания) получает 2 случайные Модификации ИЗ КОЛОДЫ владельца, кроме
// Оптического камуфляжа (Скрытности).
//
// Из колоды — то есть Моды ТРАТЯТСЯ из колоды (как при обычном розыгрыше).
// Если в колоде <2 Модов — берёт сколько есть.
//
// Прицепление через стандартный attachMod БЕЗ source.isPlayed (триггер, не
// розыгрыш). Бишор-триггер «союзник получил Мод» срабатывает на каждое
// прицепление; Хирург НЕ срабатывает (это не розыгрыш карты Мода);
// прогрессия урона Герою НЕ тикает.
//
// Легендарка → Режим ожидания (4-й ход). Пассивка фиксирует флаг
// onSpawnPassiveFired и срабатывает один раз — в момент пробуждения.

import { attachMod } from './modifications.js';

export const CARD_ID = 'syn_lichnyy_telohranitel';
const EXCLUDED_MOD_ID = 'syn_mod_kamuflyazh';
const NUM_MODS = 2;

export function lichnyyOnSpawn(state, ownerIdx, card) {
  if (!card || card.id !== CARD_ID) return;
  if (!card.isAlive()) return;
  const p = state.players[ownerIdx];
  // Кандидаты в колоде: type='mod', не Камуфляж.
  const pool = p.deck.filter(c => c.type === 'mod' && c.id !== EXCLUDED_MOD_ID);
  const pickCount = Math.min(NUM_MODS, pool.length);
  if (pickCount === 0) {
    state.log.add(`🛡 ${card.name_ru} [${p.name}]: в колоде нет Модов (кроме Камуфляжа) — пассивка пуста`);
    return;
  }
  const picked = [];
  const localPool = [...pool];
  for (let i = 0; i < pickCount; i++) {
    const j = state.rng.int(localPool.length);
    const modCard = localPool.splice(j, 1)[0];
    // Удаляем Мод из настоящей колоды.
    const deckIdx = p.deck.indexOf(modCard);
    if (deckIdx >= 0) p.deck.splice(deckIdx, 1);
    picked.push(modCard);
  }
  state.log.add(
    `🛡 ${card.name_ru} [${p.name}]: пассивка — ${picked.length} Мод(а) из колоды ` +
    `(${picked.map(m => m.name_ru).join(', ')})`
  );
  for (const modCard of picked) {
    if (!card.isAlive()) break;       // вдруг умер от Перегрузки в каскаде
    attachMod(state, card, { id: modCard.id, name_ru: modCard.name_ru }, {
      cardId: CARD_ID, ownerIdx
    });
    // Картa Мод-шаблона тратится — в discard (НЕ обратно в колоду).
    p.discard.push(modCard);
  }
}
